import { z } from "zod";
import {
  TopolBlockCssClassSchema,
  TopolBlockAlignSchema,
  TopolBlockSchema,
  TopolColorSchema,
} from "../commonSchema";

const TopolSocialElementSchema = z.object({
  tagName: z.literal("mj-social-element"),
  attributes: z
    .object({
      src: z.string().trim().catch(""),
      name: z.string().catch(""),
      alt: z.string().catch(""),
      href: z.string().trim().catch(""),
      "background-color": TopolColorSchema.catch("transparent"),
      show: z.union([z.literal(true), z.literal(false)]).catch(true),
    })
    .default({
      src: "",
      name: "",
      alt: "",
      href: "",
      "background-color": "transparent",
      show: true,
    }),
});

const defaultSocialBlockStyleAttributes = {
  padding: "10px 10px 10px 10px",
  "icon-size": "35px",
  align: "center" as const,
  containerWidth: 600,
  "text-mode": "false" as const,
};

export const TopolSocialBlockStyleAttributesSchema = z.object({
  padding: z.string().catch(defaultSocialBlockStyleAttributes["padding"]),
  "icon-size": z.string().catch(defaultSocialBlockStyleAttributes["icon-size"]),
  align: TopolBlockAlignSchema.catch(
    defaultSocialBlockStyleAttributes["align"]
  ),
  "icon-padding": z.string().optional().catch(undefined),
});

export const TopolSocialBlockSchema = TopolBlockSchema.extend({
  tagName: z.literal("mj-social"),
  attributes: z
    .object({
      ...TopolSocialBlockStyleAttributesSchema.shape,
      "text-mode": z
        .literal("false")
        .catch(defaultSocialBlockStyleAttributes["text-mode"]),
      containerWidth: z
        .number()
        .catch(defaultSocialBlockStyleAttributes["containerWidth"]),
      "css-class": TopolBlockCssClassSchema.optional().catch(undefined),
    })
    .default(defaultSocialBlockStyleAttributes),
  children: z.array(TopolSocialElementSchema).default([]),
  style: z.string().optional().catch(undefined),
});

export type TopolSocialBlock = z.infer<typeof TopolSocialBlockSchema>;
